import { graphql, useStaticQuery } from 'gatsby';
import GlobalWrapper from 'layouts/GlobalWrapper';
import SEO from 'layouts/SEO';
import { useLocation } from 'react-use';

import { contentfulProps } from 'assets/mockData/emptyTypes';

import Footer from 'components/Footer/Footer';
import GlobalModalForm from 'components/Form/GlobalModalForm';
import Header from 'components/Header';

import type {
  ContentfulComponentFooter,
  ContentfulComponentForm,
  ContentfulComponentHeader,
  ContentfulMetaSeo,
} from 'graphqlTypes';
import type { FC, ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
  slug: string;
  seo?: ContentfulMetaSeo | null;
  header?: ContentfulComponentHeader | null;
  footer?: ContentfulComponentFooter | null;
}

interface LayoutData {
  contentfulComponentHeader: ContentfulComponentHeader;
  contentfulComponentFooter: ContentfulComponentFooter;
  header: ContentfulComponentHeader;
  footer: ContentfulComponentFooter;
  landingPageHeaderForm: ContentfulComponentForm;
}

const Layout: FC<LayoutProps> = ({ slug, seo, children, header, footer }) => {
  const { pathname } = useLocation();

  const isChildrenComponentArray = Array.isArray(children?.[0]);
  const featuredImageUrl =
    isChildrenComponentArray &&
    children?.[0]?.find(entry => entry?.props?.component?.__typename === 'ContentfulComponentHero')?.props?.component
      ?.reference?.imageDesktop?.file?.url;

  const isNoNav = pathname?.includes('merchantportal');

  const { contentfulComponentFooter, contentfulComponentHeader, landingPageHeaderForm } =
    useStaticQuery<LayoutData>(graphql`
      query layoutQuery {
        contentfulComponentHeader(contentful_id: { eq: "1t4B6M15T43coxtLFw2286" }) {
          ...ContentfulComponentHeader
        }
        contentfulComponentFooter(contentful_id: { eq: "1CCOFcH7kTEL6LtNQsNI6t" }) {
          ...contentfulComponentFooter
        }
        landingPageHeaderForm: contentfulComponentForm(contentful_id: { eq: "1PD9ndIcvzjJAxHvc5am3l" }) {
          ...contentfulComponentForm
        }
      }
    `);

  return (
    <GlobalWrapper>
      {!isNoNav && (
        <Header
          slug={slug}
          {...(header ? { ...header } : { ...contentfulComponentHeader })}
          isHomePage={slug === '/'}
          landingPageHeaderForm={landingPageHeaderForm}
        />
      )}
      <SEO
        ogFeaturedImage={featuredImageUrl ? `https:${featuredImageUrl}` : null}
        slug={slug}
        {...contentfulProps}
        {...seo}
      />
      {children}
      <Footer {...(footer ? { ...footer } : { ...contentfulComponentFooter })} />
      <GlobalModalForm />
    </GlobalWrapper>
  );
};

export default Layout;
